import { responsiveMap } from 'antd/lib/_util/responsiveObserve';
export const setNewBreakpoints = ()=>{
    responsiveMap.xs = "(max-width: 450px)";
}
